import { createActionNameForProcessingFetch } from '../../utils/helpers/actionCreatorHelpers';
import { IMAGES_DOMAIN_NAME } from './constants';

// eslint-disable-next-line import/prefer-default-export
export const createImageConstants = createActionNameForProcessingFetch('createImage', IMAGES_DOMAIN_NAME);

export const getImagesConstants = createActionNameForProcessingFetch('getImages', IMAGES_DOMAIN_NAME);

export const deleteImageConstants = createActionNameForProcessingFetch('deleteImage', IMAGES_DOMAIN_NAME);
